import type { Column } from '@tanstack/react-table';
import type { CSSProperties } from 'react';

export const getPinningStyles = <T>(column: Column<T>): CSSProperties => {
  const isPinned = column.getIsPinned();
  return {
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    width: column.getSize(),
    zIndex: isPinned ? 10 : 0,
  };
};

export const getTableLayoutStyles = (options?: { margin?: number }) => {
  return {
    height: `calc(100vh - (83px + 24px) - ${options?.margin || 16}px)`,
    position: 'sticky' as const,
    top: '16px',
  };
};
